import React from 'react';

/**
 * GTM 板块 · 亲历战役 × 方法沉淀
 * ------------------------------------------------
 * 4 张战役卡：
 *   1) AICP · 深圳区 0→1 (冷启能力)
 *   2) AI Coding · 央企首单 (打样能力)
 *   3) 车企桌面云 · 标杆 → 行业复制 (复制能力)
 *   4) 汽车行业经营分析 (行业视角能力)
 * 底部锚点：方法论作为"训练背景标签"低调出现,不占版面
 */

interface Battle {
  n: string;
  icon: string;
  category: string;      // 战役类型 · 用于胶囊标签
  categoryColor: 'orange' | 'purple' | 'cyan' | 'green';
  title: string;
  subtitle?: string;
  rows: { label: string; value: string; highlight?: boolean }[];
}

const BATTLES: Battle[] = [
  {
    n: '01',
    icon: 'fa-rocket',
    category: '区域探索',
    categoryColor: 'orange',
    title: 'AICP / FastGPT · 深圳区 AI 项目起步',
    subtitle: '公司 AI 产品早期区域起步 · 场景挖掘 + 客户共建',
    rows: [
      { label: '起步', value: '负责深圳区 AI 项目起步探索' },
      { label: '探索', value: '探索深信服 AI 产品在区域的推广路径' },
      { label: '成果', value: '7 个月 · 承担 10+ 共建客户 · 供其他区域参考', highlight: true },
    ],
  },
  {
    n: '02',
    icon: 'fa-trophy',
    category: '央企首单突破',
    categoryColor: 'purple',
    title: 'AI Coding · 央企首单突破',
    subtitle: '公司 AI Coding 业务首单 · 与总部并肩打透央企 KA',
    rows: [
      { label: '客户', value: 'XX 头部央企集团 · 下属 7 家科一智公司全部研发推广使用', highlight: true },
      { label: '突破', value: '公司 AI Coding 业务首单落地' },
      { label: '沉淀', value: '与总部共同作战 · 探索 AI Coding 攻客路径 + KA 打法 SOP' },
    ],
  },
  {
    n: '03',
    icon: 'fa-industry',
    category: '共建突破 → 全国复制',
    categoryColor: 'cyan',
    title: '车企桌面云 · 从共建突破到全国复制',
    subtitle: '共建头部车企标杆 · 沉淀行业模式 · 反向驱动产品迭代',
    rows: [
      { label: '标杆', value: '头部车企 8W 点 · 公司最大桌面云案例', highlight: true },
      { label: '沉淀', value: '沉淀出车企 / 大 KA 客户桌面云突破与替换最佳实践经验' },
      { label: '复制', value: '带动全国 10+ 车企行业案例落地' },
      { label: '驱动', value: '反向驱动产线优化 · 产品改进 20+ 项 + 架构层优化', highlight: true },
    ],
  },
  {
    n: '04',
    icon: 'fa-chart-line',
    category: '与总部共创',
    categoryColor: 'green',
    title: '汽车行业方案与打法 · 与总部共创',
    subtitle: '从卖设备 → 懂客户经营 · 与总部联合输出行业级方案与打法',
    rows: [
      { label: '共创', value: '联合总部行业组共创汽车行业解决方案与打法策略', highlight: true },
      { label: '视角', value: '汽车行业客户经营地图 · 业务链路 / KPI / 痛点分析' },
      { label: '沉淀', value: '从技术方案售前 → 懂行业经营的行业型 SA 进阶' },
    ],
  },
];

export const GTMMethodology: React.FC = () => {
  return (
    <section className="gtm-section" data-testid="section-gtm">
      <div className="gtm-inner">
        <header className="gtm-header">
          <div className="gtm-eyebrow">BATTLES · METHOD · SCALE</div>
          <h2 className="gtm-title">亲历战役 · 方法沉淀</h2>
          <p className="gtm-subtitle">
            每一单不只是拿下 —— 更把打法沉淀为可复制的模式：区域探索 · 央企突破 · 行业复制 · 与总部共创
          </p>
        </header>

        {/* 4 张亲历战役卡 */}
        <div className="gtm-battle-grid">
          {BATTLES.map((b) => (
            <article key={b.n} className={`gtm-battle gtm-battle--${b.categoryColor}`}>
              <div className="gtm-battle-head">
                <span className="gtm-battle-icon">
                  <i className={`fa-solid ${b.icon}`} />
                </span>
                <div className="gtm-battle-head-text">
                  <span className="gtm-battle-cat">{b.category}</span>
                  <h3 className="gtm-battle-title">{b.title}</h3>
                  {b.subtitle && <p className="gtm-battle-subtitle">{b.subtitle}</p>}
                </div>
                <span className="gtm-battle-num">{b.n}</span>
              </div>

              <ul className="gtm-battle-rows">
                {b.rows.map((r) => (
                  <li key={r.label} className={r.highlight ? 'is-highlight' : ''}>
                    <span className="gtm-battle-row-label">{r.label}</span>
                    <span className="gtm-battle-row-value">{r.value}</span>
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GTMMethodology;
